export interface MxMerchantSettingModel {
  consumerKey: string;
  consumerSecret: string;
  merchantId: string;
  isActive: boolean;
  isSandbox: boolean;
}

export abstract class PaymentGatewayCodeConst {
  public static MxMerchant = "MxMerchant";
}

export interface PaymentGatewayModel {
  paymentGatewayCode: string;
  paymentGatewayName: string;
}
